import { css } from '@emotion/react'

const noUsersToEdit = css`
  display: flex;
`

export const styles = {
  noUsersToEdit,
}
